document.addEventListener('DOMContentLoaded', () => {
  const sectionEl = document.querySelector(
    '.capsule-landing-categories[data-slider]'
  );
  const forceSliderAll = sectionEl.dataset.slider === 'true';
  const mqlMin1024 = window.matchMedia('(min-width: 1024px)');
  const instances = new WeakMap();

  function initOneCategory(catEl) {
    const container = catEl.querySelector('.capsule-slider');
    const controls = catEl.querySelector('.capsule-slider__controls');
    const wrapper = catEl.querySelector('.js-capsule-slider');
    if (!container || !controls || !wrapper) return;
    if (instances.get(container)) return;

    const prevBtn = controls.querySelector('.swiper-prev');
    const nextBtn = controls.querySelector('.swiper-next');

    const swiper = new Swiper(container, {
      wrapperClass: 'js-capsule-slider',
      slideClass: 'item',
      spaceBetween: 8,
      speed: 300,
      navigation: { prevEl: prevBtn, nextEl: nextBtn },
      keyboard: { enabled: true, onlyInViewport: true },
      a11y: {
        enabled: true,
        prevSlideMessage: 'Previous',
        nextSlideMessage: 'Next'
      },
      slidesPerView: 'auto',
      breakpoints: {
        1024: { slidesPerView: 3, spaceBetween: 16 },
        1440: { slidesPerView: 4, spaceBetween: 16 }
      },
      on: {
        init() {
          container.classList.add('swiper-initialized');
        }
      }
    });

    swiper.on('slideChange', swiper => {
      const categoryEl = container.closest('.capsule-category');
      calculateScrollPercentage(swiper, categoryEl);
    });

    instances.set(container, swiper);
  }

  function destroyOneCategory(catEl) {
    const container = catEl.querySelector('.capsule-slider');
    const swiper = instances.get(container);
    if (!swiper) return;

    swiper.destroy(true, true);
    container.classList.remove('swiper-initialized');
    instances.delete(container);
  }

  function initOrDestroy() {
    document.querySelectorAll('.capsule-category').forEach(cat => {
      if (forceSliderAll) {
        initOneCategory(cat);
      } else {
        if (mqlMin1024.matches) {
          initOneCategory(cat);
        } else {
          destroyOneCategory(cat);
        }
      }
    });
  }

  initOrDestroy();
  mqlMin1024.addEventListener('change', initOrDestroy);

  const revealBar = sectionEl.querySelector(
    '.capsule-landing-categories .reveal-bar'
  );
  if (!revealBar) return;

  let sectionObserver = null;
  let rbPlaceholder = null;
  let rbMovedToBody = false;

  function showRevealBar() {
    revealBar.classList.remove('tw-translate-y-18x');
    revealBar.classList.add('tw-translate-y-0');
    revealBar.style.removeProperty('--tw-translate-y');
  }

  function hideRevealBar(isDesktop) {
    revealBar.classList.remove('tw-translate-y-0');
    if (isDesktop) {
      revealBar.classList.add('tw-translate-y-18x');
      revealBar.style.removeProperty('--tw-translate-y');
    } else {
      revealBar.classList.remove('tw-translate-y-18x');
      revealBar.style.setProperty('--tw-translate-y', '100%');
    }
  }

  function setupRevealBar(isDesktop) {
    if (sectionObserver) {
      sectionObserver.disconnect();
      sectionObserver = null;
    }

    if (isDesktop) {
      if (rbMovedToBody && rbPlaceholder && rbPlaceholder.parentNode) {
        rbPlaceholder.parentNode.insertBefore(revealBar, rbPlaceholder);
        rbPlaceholder.remove();
        rbPlaceholder = null;
        rbMovedToBody = false;
      }
    } else {
      if (!rbMovedToBody) {
        rbPlaceholder = document.createComment('reveal-bar-placeholder');
        revealBar.parentNode.insertBefore(rbPlaceholder, revealBar);
        document.body.appendChild(revealBar);
        rbMovedToBody = true;
      }
    }

    hideRevealBar(isDesktop);

    var visibilityThreshold = isDesktop ? 0.3 : 0.1;

    sectionObserver = new IntersectionObserver(
      entries => {
        entries.forEach(entry => {
          if (entry.intersectionRatio >= visibilityThreshold) {
            showRevealBar();
          } else {
            hideRevealBar(isDesktop);
          }
        });
      },
      { threshold: visibilityThreshold }
    );
    sectionObserver.observe(sectionEl);
  }

  function updateRevealBarMode() {
    setupRevealBar(mqlMin1024.matches);
  }

  updateRevealBarMode();
  mqlMin1024.addEventListener('change', updateRevealBarMode);
});
